import { Video, Trophy, BookOpenCheck, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import AdminSectionLayout from "../components/admin/AdminSectionLayout";
import AdminTile from "../components/admin/AdminTile";

/**
 * AdminReviews — Feb 6, 2026 (preview-fix Feb 6, 2026 PM).
 *
 * Only tiles that open their OWN dedicated page are shown. AI lesson
 * reviews / clip basket / processing pipeline live in the legacy
 * panel and are surfaced as one explicit link rather than multiple
 * tiles that all open the same page.
 */
export default function AdminReviews() {
  return (
    <AdminSectionLayout
      title="Reviews & uploads"
      subtitle="AI lesson reviews · clip basket · uploads · processing"
      icon={Video}
      accent="violet"
      testid="admin-reviews-page"
    >
      <AdminTile
        to="/admin/teaching-excellence"
        icon={Trophy}
        label="Teaching Excellence queue"
        desc="Moderation queue for instructor recognition tier"
        accent="amber"
        testid="admin-reviews-tile-teaching-excellence"
      />
      <AdminTile
        to="/admin/learner-stories"
        icon={BookOpenCheck}
        label="Learner stories"
        desc="Pupil submissions awaiting publish / decline"
        accent="indigo"
        testid="admin-reviews-tile-learner-stories"
      />

      <Link
        to="/admin/legacy"
        data-testid="admin-reviews-legacy-link"
        className="flex items-center gap-2 mt-4 px-4 py-3 rounded-xl text-xs text-slate-500 hover:text-slate-700 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors"
      >
        <ExternalLink className="w-3.5 h-3.5" />
        <span>AI reviews · clip basket · processing status (legacy panel)</span>
      </Link>
    </AdminSectionLayout>
  );
}
